<template>
  <div>
    <PageAllow controller="StockOrderAnalyze" action="details" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 入库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                type="datetime"
                v-model="options"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-tooltip
                v-if="
                  $permission.permissionAllow(
                    'StockOrderAnalyze',
                    'detailExport'
                  )
                "
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1"
                    @click.stop="exportExcel()"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("StockDetails.export") }}
                  </v-btn>
                </template>
                <span>{{ $t("StockDetails.export") }}</span>
              </v-tooltip>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterial v-model="materialSelected" />
                </v-col>
                <!-- 类型 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.order_flgs"
                    :label="$t('stockOrderAnalyze.DetailFields.inOutType')"
                    :items="$consts.outInFlgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="in_out_detail"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend v-if="options.order_flgs.length == 1">
              <tr class="d-none d-sm-table-row">
                <td colspan="6">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td class="text-center"><span>{{ orderNumTotal }}</span></td>
                <td class="text-center"><span>{{ confirmNumTotal }}</span></td>
                <td colspan="2"></td>
              </tr>
            </template>
            <!-- 单号 -->
            <template v-slot:item.code="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_order_code }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <!-- 出入4库类型 -->
            <template v-slot:item.type="{ item }">
              <span>
                {{ item.in_type_str ? item.in_type_str : item.out_type_str }}
              </span>
            </template>
            <!-- 商品 -->
            <template v-slot:item.material_name="{ item }">
              <span class="text-no-wrap">
                {{item.material_name, }}
              </span>
              <br />
              <span v-if="item.standard_name" class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
                }}<span
                  v-if="item.standard_name && item.standard_name.length > 12"
                  :title="item.standard_name"
                  style="cursor: pointer"
                >
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </span>
            </template>
            <!-- 出入库类型 -->
            <template v-slot:item.order_flg="{ item }">
              <v-chip
                small
                label
                :color="item.order_flg | outInFlgsColor"
                :text-color="item.order_flg | outInFlgsTextColor"
              >
                {{ item.order_flg | outInFlgsText }}
              </v-chip>
            </template>
            <!-- <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template> -->
            <!-- 出入库 -->
            <template v-slot:item.order_num="{ item }">
              {{ item.order_num ? item.order_num : 0 }}{{ item.unit }}
            </template>

            <!-- 实际出入库 -->
            <template v-slot:item.actual_num="{ item }">
              {{ item.actual_num ? item.actual_num : 0 }}{{ item.unit }}
            </template>

            <!-- 单价 -->
            <template v-slot:item.price="{ item }">
              {{ $t("Global.money") }}{{ item.price | formatMoney }}
            </template>
            <!-- 小计 -->
            <template v-slot:item.sub_total="{ item }">
              {{ $t("Global.money") }}{{ item.sub_total | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import stockOrderAnalyze from "@/api/stock_order_analyze";
import SearcherMaterial from "./plugins/SearcherMaterial";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  material_id: null,
  order_flgs: [1, 2],
};

export default {
  name: "stockOrderAnalyzeDetails",
  data: () => ({
    in_out_detail: [],
    materialSelected: null,
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    orderNumTotal: null,
    confirmNumTotal: null,
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherMaterial,
    SearcherStatus,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    ...mapState(["accountSettings"]),
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/current-stocks",
      },
      {
        text: i18n.t("Nav.stockOrderAnalyze"),
        disabled: true,
        href: "/stock-order-analyze",
      },
      {
        text: i18n.t("Nav.inOutDetail"),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("stockOrderAnalyze.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("stockOrderAnalyze.Fields.actual_time"),
      },
    ],
    headers: () => [
      // 单号
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.code"),
        align: "start",
        sortable: false,
        width: "165px",
        value: "code",
      },
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.type"),
        align: "start",
        sortable: false,
        value: "type",
      },
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.material_code"),
        align: "center",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.material_name"),
        align: "center",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.order_flg_str"),
        align: "center",
        sortable: false,
        value: "order_flg",
      },
      // 单价
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.price"),
        align: "center",
        sortable: false,
        value: "price",
      },
      // 出入库量
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.order_num"),
        align: "center",
        sortable: false,
        value: "order_num",
      },
      // 实际 出入库量
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.actual_num"),
        align: "center",
        sortable: false,
        value: "actual_num",
      },
      // 小计
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.sub_total"),
        align: "end",
        sortable: false,
        value: "sub_total",
      },
      // 操作人
      {
        text: i18n.t("stockOrderAnalyze.DetailFields.executer_name"),
        align: "end",
        sortable: false,
        value: "operater_name",
      },
    ],
  },

  mounted() {
    this.$commonUtils
      .loadOptions("stockIN-and-stockOUT", []).then(
      function (data) {
        if (data.options) {
          this.options.created_time_from = data.options.created_time_from;
          this.options.created_time_to = data.options.created_time_to;
        }
        // this.resetSearch();
        this.options.material_id = this.$route.params.id;
      }.bind(this)
    );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.materialSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getStockOrderAnalyzeFromAPI() {
      this.loading = true;
      stockOrderAnalyze.fetchOne(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.in_out_detail = response.data.in_out_detail;
            this.orderNumTotal = response.data.order_num_total;
            this.confirmNumTotal = response.data.confirm_num_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      stockOrderAnalyze.detailExport(this.options);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.materialSelected = Number(this.$route.params.id);
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStockOrderAnalyzeFromAPI();
      },
    },
    // 商品
    materialSelected: {
      immediate: true,
      handler() {
        this.options.material_id = this.materialSelected
          ? this.materialSelected
          : null;
      },
    },
  },
};
</script>

<style>
</style>